export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

// VIDEOS
export const FETCH_VIDEOS = "FETCH_VIDEOS"
export const VIDEOS_SUCCESS = "VIDEOS_SUCCESS"
export const VIDEOS_FAIL = "VIDEOS_FAIL"
export const CREATE_VIDEOS = "CREATE_VIDEOS"
export const UPDATE_VIDEO = "UPDATE_VIDEO"
export const DELETE_VIDEO = "DELETE_VIDEO"

//IMAGES

export const FETCH_IMAGES = "FETCH_IMAGES"
export const IMAGES_SUCCESS = "IMAGES_SUCCESS"
export const IMAGES_FAIL = "IMAGES_FAIL"
export const IMAGES_SUCCESS_ACTION = "IMAGES_SUCCESS_ACTION"


//BANCO
export const FETCH_BANCOS = "FETCH_BANCOS"
export const BANCOS_SUCCESS = "BANCOS_SUCCESS"
export const BANCOS_FAIL = "BANCOS_FAIL"
export const UPDATE_BANCO = "UPDATE_BANCO"
export const START_PAYMENT_SERVICE = "START_PAYMENT_SERVICE"
export const SET_CLIENT_DATA= "SET_CLIENT_DATA"
export const FINISH_LOADING = "FINISH_LOADING"